var _script, _script2, _linearGradient, _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    id: "argent-x-extension",
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -14.94,
    y1: 914.64,
    x2: 1159.05,
    y2: -86.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#15fd85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1ff896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#30f1b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#48e7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5fddff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 500,
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#121312}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient)"
    },
    d: "M-48-81.5h1050v1153H-48z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M780.07 499.81h-68.31c-20.4 0-36.93 16.54-36.93 36.93v99.14c0 20.4-16.54 36.93-36.93 36.93H366.13c-20.4 0-36.93 16.54-36.93 36.93v68.31c0 20.4 16.54 36.93 36.93 36.93h287.5c20.4 0 36.71-16.54 36.71-36.93v-54.8c0-20.4 16.54-34.88 36.93-34.88h52.8c20.4 0 36.93-16.54 36.93-36.93V536.3c0-20.4-16.54-36.5-36.93-36.5ZM329.18 364.11c0-20.4 16.54-36.93 36.93-36.93h271.6c20.4 0 36.93-16.54 36.93-36.93v-68.31c0-20.4-16.54-36.93-36.93-36.93H350.37c-20.4 0-36.93 16.54-36.93 36.93v52.63c0 20.4-16.54 36.93-36.93 36.93h-52.57c-20.4 0-36.93 16.54-36.93 36.93v115.26c0 20.4 16.6 36.1 37 36.1h68.31c20.4 0 36.93-16.54 36.93-36.93l-.06-98.74ZM469.85 428.01h65.62c21.38 0 38.74 17.36 38.74 38.74v65.62c0 21.38-17.36 38.74-38.74 38.74h-65.62c-21.38 0-38.74-17.36-38.74-38.74v-65.62c0-21.38 17.36-38.74 38.74-38.74Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeLogo);
export default __webpack_public_path__ + "static/media/safe-logo.abe3d4492b10476a41bcf6ef464fe318.svg";
export { ForwardRef as ReactComponent };